module.exports = __webpack_public_path__ + "img/purple-penguin.4a480442.svg";